import "bootstrap-sass";
import "jquery-match-height";

import "./modules/webfont";
// import "./modules/page-top";
import "./modules/jqueryvalidation";
import "./modules/menu-trigger";
// import "./modules/bs.tab";
// import "./modules/js-header";
// import "./modules/js-footer";
import "./modules/nav";
// import "./modules/waypoints";
import "./modules/dropdown-hover";
import "./modules/swiper-fv";
import "./modules/aos";
import "./modules/input-file";
import "./modules/acceptance-checkbox";
import "./modules/active-tab";
import "./modules/smoothScroll";
import "./modules/jquery-match-height";
import "./modules/scroll-table";

// import ScrollMagic from "scrollmagic";
